import { render, staticRenderFns } from "./DHSchemaNode.vue?vue&type=template&id=9fa51260&scoped=true&"
import script from "./DHSchemaNode.vue?vue&type=script&lang=js&"
export * from "./DHSchemaNode.vue?vue&type=script&lang=js&"
import style0 from "./DHSchemaNode.vue?vue&type=style&index=0&id=9fa51260&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa51260",
  null
  
)

export default component.exports